module.exports = __webpack_public_path__ + "assets/img/consideration-7-problemes-cycle-vie-doc.1e1c7d8f.jpg";